<template>
  <div class="checkout-builder-video-modal">
    <h5>Selecione um ou dos dois dispositivos:</h5>
    <snow-checkbox-group
      v-model="form.config.display"
      :options="[
        { id: 'mobile', name: 'Versão para celular' },
        { id: 'desktop', name: 'Versão para computador' }
      ]"
    />

    <snow-input v-model="form.text" required id="text" label="URL do vídeo" />

    <snow-select
      v-model="form.config.ratio"
      required
      id="ratio"
      label="Proporção"
      :options="ratioOptions"
    />

    <div class="snow-submit-buttons mt-3">
      <snow-button
        size="lg"
        variant="gray"
        text="Cancelar"
        @click="$emit('close')"
      />
      <snow-button
        size="lg"
        text="Inserir vídeo"
        @click="save"
        :disabled="!isValid"
      />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
export default {
  props: {
    position: {
      type: String,
      default: ""
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ...formFields(["text", "config"], {
        ...this.data,
        config: {
          ratio: "16by9",
          display: ["desktop", "mobile"],
          ...this.data.config
        }
      }),
      ratioOptions: [
        { id: "21by9", name: "21:9" },
        { id: "16by9", name: "16:9" },
        { id: "4by3", name: "4:3" },
        { id: "1by1", name: "1:1" }
      ]
    };
  },
  computed: {
    isValid() {
      return this.form.text && this.form.config.ratio;
    }
  },
  methods: {
    save() {
      this.$emit("save", { ...this.data, type: "video", ...this.form });
    }
  }
};
</script>
<style lang="scss" scoped>
.checkout-builder-video-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
  .bp-input-file .input-container {
    aspect-ratio: 2.7;
  }
}
</style>
